export default __webpack_public_path__ + "static/media/962.202cb24d.png";